import { render, staticRenderFns } from "./priceAdjustmentStatistics.vue?vue&type=template&id=2ea9a9ff&scoped=true"
import script from "./priceAdjustmentStatistics.vue?vue&type=script&lang=js"
export * from "./priceAdjustmentStatistics.vue?vue&type=script&lang=js"
import style0 from "./priceAdjustmentStatistics.vue?vue&type=style&index=0&id=2ea9a9ff&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea9a9ff",
  null
  
)

export default component.exports